import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

type BlueprintProps = {
    className?: string;
};

const Blueprint: FunctionComponent<BlueprintProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'blueprint'}
            viewBox="0 0 250 250"
        >
            <path d="M46.1 210.7H0V250h216.8v-39.3H46.1zM22.7 245H5v-29.3h17.7V245zm5.2 0v-29.3h6.5V245h-6.5zm18.2 0h-6.5v-29.3h6.5V245zm5-29.3h160.7V245H51.1v-29.3z" />
            <path d="M221.5 210.7V250l27.6-19.7-27.6-19.6zm5 9.7l13.9 9.9-13.9 9.9v-19.8z" />
            <path d="M0 0v195.5h250V0H0zm245 190.5H5V5h240v185.5z" />
            <polygon points="79.5,164.9 27.7,164.9 27.7,100.1 79.5,100.1 79.5,95.1 27.7,95.1 27.7,30.1 156.4,30.1 156.4,95.1 104.5,95.1 104.5,100.1 156.4,100.1 156.4,164.9 104.5,164.9 104.5,169.9 161.4,169.9 161.4,100.1 226.1,100.1 226.1,25.1 203.4,25.1 203.4,25.6 203.2,25.3 185.7,42.8 189.2,46.3 205.5,30.1 221.1,30.1 221.1,95.1 161.4,95.1 161.4,30.1 178.5,30.1 178.5,25.1 161.4,25.1 161.4,25.1 22.7,25.1 22.7,169.9 79.5,169.9" />
        </svg>
    );
};
export default Blueprint;
